import { render, staticRenderFns } from "./ManageUnitsModal.vue?vue&type=template&id=48c67d03&scoped=true"
import script from "./ManageUnitsModal.vue?vue&type=script&lang=js"
export * from "./ManageUnitsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageUnitsModal.vue?vue&type=style&index=0&id=48c67d03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c67d03",
  null
  
)

export default component.exports